export default __webpack_public_path__ + "static/media/CureBayLogo.aa0235cc.svg";